<template lang="pug">
v-list-tile.tile
	.background-layer(
		:style="backgroundStyle"
		)
		span.delete-message
			v-icon(color="white") delete
			span.font-weight-bold ELIMINAR
	.mobile.swipe(
		:style="swipeStyle"
		)
		div.controls-layer(
			@touchmove="dragHandler($event)"
			@touchend="endHandler($event)"
			)
			.left-button(
				@touchstart="leftButtonStart($event)"
				@touchend="leftButtonEnd($event)"
				:class="{ active: activeLeft }"
				)
				span.font-weight-bold.white--text.btn-text.display-3 -
			.right-button(
				@touchstart="rightButtonStart($event)"
				@touchend="rightButtonEnd($event)"
				:class="{ active: activeRight }"
				)
				span.font-weight-bold.white--text.btn-text.display-1 +
		div.tile-content 
			slot
</template>

<script>
import swipeListTile from './swipeListTile.js'
export default swipeListTile
</script>

<style lang="scss" scoped>
@import './swipeListTile';
</style>
